module.exports = __webpack_public_path__ + "media/newstyle/images/chevron-right-black-32add9b1104be71eaf31ce0fe0373d58.svg";